<template>
  <v-container
    fluid
  >
    <v-form
        ref="form"
    >
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-title class="headline">比較基準の設定</v-card-title>
          <v-divider class="mx-3"></v-divider>
          <v-row
            justify="center"
            align-content="center"
          >
            <!-- 対象店舗 -->
            <v-col cols="3">
              <v-subheader>対象店舗<span class="required_mark">*</span></v-subheader>
            </v-col>
            <v-col cols="8" class="input-col">
              <v-select
                outlined
                dense
                item-value="id"
                v-model="store.store_id"
                label="店舗コード"
                :items="companyStores"
                :rules="[v => !!v || '']"
                required
              >
                <template v-slot:selection="{item}">
                  {{ item.store_code }}:{{ item.store_name }}
                </template>
                <template v-slot:item="{item}">
                  {{ item.store_code }}:{{ item.store_name }}
                </template>
              </v-select>
            </v-col>
            <!-- ./対象店舗 -->
          </v-row>
          <v-divider class="mx-3"></v-divider>
          <v-row
            justify="center"
            align-content="center"
          >
            <!-- 業種 -->
            <v-col cols="3">
              <v-subheader>業種<span class="required_mark">*</span></v-subheader>
            </v-col>
            <v-col cols="8" class="input-col">
              <v-select
                outlined
                dense
                item-value="id"
                item-text="name"
                v-model="store.industry_id"
                label="業種"
                :items="industries"
                :rules="[v => !!v || '']"
                required
              />
            </v-col>
            <!-- ./対象店舗 -->
          </v-row>
          <v-divider class="mx-3"></v-divider>
          <v-row
            justify="center"
            align-content="center"
          >
            <!-- 業種 -->
            <v-col cols="3">
              <v-subheader>企業規模<span class="required_mark">*</span></v-subheader>
            </v-col>
            <v-col cols="8" class="input-col">
                <v-select
                  outlined
                  dense
                  item-value="id"
                  item-text="name"
                  v-model="store.seat_num"
                  label="席数"
                  :items="seatNums"
                  :rules="[v => !!v || '']"
                  required
                />
            </v-col>
            <!-- ./対象店舗 -->
          </v-row>
          <v-divider class="mx-3"></v-divider>

          <v-row
          class="text-center mt-5 pb-5">
            <v-col cols="12">
              <v-btn
                  class="common-save-btn"
                  width="200px"
                  @click="saveComparison"
              >
                設定
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-form>
  </v-container>
</template>

<script>
import {
  checkComparison,
  checkResponse,
  clearData,
  SAVE_STORE_GRAPH,
  SAVE_STORE_SUMMARY,
  sendGetParallelApi,
  sendPutParallelApi
} from "../../../../util";

export default {
 data () {
    return {
      store: {
        store_id: '',
        industry_id: '',
        seat_num: '',
      },
      companyStores: [],
      industries: [],
      estimateSales: [],
      seatNums: [],
    }
  },
  mounted() {
    checkComparison(function(result, store) {
      store.commit('comparison/setIsComparisonStatus', result)
    },this.$store);
    this.initialize()
  },
  methods: {
    initialize() {
      // 各種値をAPIで取得する
      const apis = [
        // url : callback
        {url:  '/comparison', params: {}, callback: this.setUserBaseComparisons},
        {url:  '/target', params: {}, callback: this.setTarget},
        {url:  '/industry', params: {}, callback: this.setIndustry},
        {url:  '/storeScale/seatNum', params: {}, callback: this.setSeatNum},
      ];
      sendGetParallelApi(apis)
    },
    setUserBaseComparisons(response) {
      if(checkResponse(response)) {
        this.store.industry_id = response.data.data.industry_id;
        this.store.seat_num = response.data.data.seat_num;
        this.store.store_id = response.data.data.store_id;
      }
    },
    setIndustry(response) {
      if(checkResponse(response)) {
        this.industries = response.data.data;
      }
    },
    setSeatNum(response) {
      if(checkResponse(response)) {
        this.seatNums = response.data.data;
      }
    },
    setTarget(response) {
      if(checkResponse(response)) {
        this.companyStores = response.data.data
      }
    },
    async saveComparison() {
      const apis = [
        {url:  '/comparison', params: this.store, callback: this.setComparison}
      ];
      await sendPutParallelApi(apis);
    },
    setComparison(response) {
      if(checkResponse(response)) {
        // 登録後、結果をリセットして登録はサマリ/グラフの画面で行う
        clearData(SAVE_STORE_SUMMARY)
        clearData(SAVE_STORE_GRAPH)
        this.$store.dispatch('comparison/reset');
        // 登録完了したらサマリページへ
        this.$router.push('/comparison/summary');
      } else {
        this.$refs.form.validate()
      }
    }
  }
}
</script>

<style scoped>
  .input-col {
    margin-top: 12px;
    margin-bottom: 12px;
  }
</style>